export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.29-1028.36",
  commitId: "7fcb8b92f2ef0b8dbfacac1f297e05983f40a068",
  commitTime: "2026-07-29T10:28:36.000Z",
});
